import { isAxiosError } from 'axios'
import { ResponseInterceptor } from '@kibsi/ks-client-sdk'
import { KibsiHttpError } from './http.error'

export function errorHandler(): ResponseInterceptor {
    const onRejected: ResponseInterceptor[1] = async (error) => {
        if (isAxiosError(error)) {
            throw new KibsiHttpError(error)
        }

        throw error
    }

    return [undefined, onRejected]
}
